export default __webpack_public_path__ + "static/media/Greenhouse Outsidecut.59c38797.jpg";